var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseRoyalBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24C4.65685 24 6 22.6569 6 21V3Z",
    fill: "#556BB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3C18 1.34315 16.6569 0 15 0C13.3431 0 12 1.34315 12 3V21C12 22.6569 13.3431 24 15 24C16.6569 24 18 22.6569 18 21V3Z",
    fill: "#556BB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseRoyalBlue);
export default __webpack_public_path__ + "static/media/pause-royal-blue.cdeff2a991049d8e801334ffddba7d92.svg";
export { ForwardRef as ReactComponent };